<div class="py-4 container-fluid teach-compensation-details-page">
  <h4 class="mb-4 teach-compensation-details-title">
    การจัดการคำขอสอนชดเชย - คำขอสอนชดเชย
  </h4>

  <div class="teach-compensation-details-card teach-compensation-user-card">
    <div class="teach-compensation-user-info">
      <div
        *ngIf="hasAcademicTermPreview()"
        class="d-flex flex-wrap column-gap-4"
        aria-label="เทอมและปีการศึกษาสำหรับสร้างคำขอสอนชดเชย"
      >
        <span>
          <strong>เทอมการศึกษา :</strong>
          {{ academicTermName() }}
        </span>
        <span>
          <strong>ปีการศึกษา :</strong>
          {{ academicYear() }}
        </span>
      </div>
      <div>
        <strong>ชื่อ - นามสกุล :</strong>
        {{ currentTeacherName() }}
      </div>
      <div>
        <strong>สาขาวิชา :</strong>
        {{ authService.currentUser()?.user?.department?.name }}
      </div>
    </div>

    <div class="teach-compensation-timetable-scroll">
      <table class="teach-compensation-timetable">
        <thead>
          <tr>
            <th class="teach-compensation-timetable-day-header">วัน - เวลา</th>
            <th
              *ngFor="let hour of timetableHours"
              class="teach-compensation-timetable-time-header"
              [attr.colspan]="hour.colSpan"
            >
              {{ hour.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of timetableRows()">
            <th class="teach-compensation-timetable-day-cell">
              <span>{{ row.thaiName }}</span>
              <span>{{ row.englishName }}</span>
            </th>
            <td
              *ngFor="let cell of row.cells"
              class="teach-compensation-timetable-cell"
              [class.teach-compensation-timetable-cell-filled]="cell.events.length > 0"
              [attr.colspan]="cell.colSpan"
            >
              <div
                *ngFor="let event of cell.events"
                class="teach-compensation-timetable-event"
                [attr.data-subject-name]="event.subjectName"
                [attr.aria-label]="event.subjectName"
              >
                <strong>{{ event.subjectLabel }}</strong>
                <span *ngIf="event.detailLabel">{{ event.detailLabel }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="teach-compensation-details-card">
    <form class="teach-compensation-details-form" [formGroup]="form" (ngSubmit)="onSave()">
      <h5 class="teach-compensation-section-title">ข้อมูลคำขอสอนชดเชย</h5>

      <div *ngIf="scheduleSubmissionLoadError()" class="teach-compensation-details-alert" role="alert">
        {{ scheduleSubmissionLoadError() }}
      </div>

      <div class="teach-compensation-form-layout" style="width: 815px; max-width: 100%;">
        <div class="row teach-compensation-form-row" style="margin-bottom: 30px;">
          <div class="col-sm-4 teach-compensation-form-col">
            <div class="teach-compensation-label">ประเภทการลา / หยุด <span>*</span></div>
            <app-select
              formControlName="leaveType"
              [labelMode]="LabelMode.NO_LABEL"
              [options]="leaveTypeOptions()"
              [searchable]="false"
              [clearable]="true"
              [error]="isInvalid('leaveType')"
              errorMessage="กรุณาเลือกประเภทการลา / หยุด"
              inputClass="teach-compensation-details-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div
            *ngIf="leaveDateFieldMode() !== 'empty'"
            class="col-sm-4 teach-compensation-form-col"
            [ngSwitch]="leaveDateFieldMode()"
          >
            <ng-container *ngSwitchCase="'manual'">
              <div class="teach-compensation-label">วันที่ลา <span>*</span></div>
              <app-datepicker
                formControlName="leaveDate"
                [labelMode]="LabelMode.NO_LABEL"
                placeholder="วันที่ลา"
                [minDate]="leaveMinSelectableDate()"
                [maxDate]="maxSelectableDate()"
                [isDisabled]="form.get('leaveDate')?.disabled ?? true"
                [error]="isInvalid('leaveDate')"
                errorMessage="กรุณาเลือกวันที่ลา"
                classes="mb-0"
                
              ></app-datepicker>
            </ng-container>

            <ng-container *ngSwitchCase="'holiday'">
              <div class="teach-compensation-label">วันที่หยุด <span>*</span></div>
              <app-select
                formControlName="holidayId"
                [labelMode]="LabelMode.NO_LABEL"
                [options]="holidays()"
                bindLabel="name"
                bindValue="id"
                [searchable]="true"
                [clearable]="true"
                [error]="isInvalid('holidayId')"
                errorMessage="กรุณาเลือกวันหยุด"
                inputClass="teach-compensation-details-select"
                classes="mb-0"
              ></app-select>
            </ng-container>

          </div>

          <div class="col-sm-4 teach-compensation-form-col">
            <div class="teach-compensation-label">
              ช่วงเวลา
              <span *ngIf="selectedLeaveTypeId !== null">*</span>
            </div>
            <app-select
              formControlName="timeRange"
              [labelMode]="LabelMode.NO_LABEL"
              [options]="availableTimeRangeOptions"
              [searchable]="false"
              [clearable]="!isTimeRangeForced"
              [isDisabled]="form.get('timeRange')?.disabled ?? true"
              [error]="isInvalid('timeRange')"
              errorMessage="กรุณาเลือกช่วงเวลา"
              inputClass="teach-compensation-details-select"
              classes="mb-0"
            ></app-select>
          </div>

        </div>

        <div class="row teach-compensation-form-row" style="margin-bottom: 30px;">
          <div class="col-sm-8 teach-compensation-form-col">
            <div class="teach-compensation-label">ชื่อรายวิชา <span>*</span></div>
            <app-select
              formControlName="subjectId"
              [labelMode]="LabelMode.NO_LABEL"
              [options]="subjectScheduleOptions()"
              bindLabel="name"
              optionBindLabel="optionLabel"
              bindValue="id"
              [searchable]="true"
              [clearable]="true"
              [isDisabled]="form.get('subjectId')?.disabled ?? true"
              [error]="isInvalid('subjectId')"
              errorMessage="กรุณาเลือกชื่อรายวิชา"
              inputClass="teach-compensation-details-select"
              classes="mb-0"
              (valueChange)="onSubjectChange($event)"
            ></app-select>
            @if (hasNoTimetableSubjects()) {
              <p class="teach-compensation-field-hint">
                ไม่พบรายวิชาในตารางสอนของท่านในภาคการศึกษานี้
              </p>
            }
          </div>

          <div class="col-sm-4 teach-compensation-form-col">
            <div class="teach-compensation-field">
              <div class="teach-compensation-label">รหัสวิชา <span>*</span></div>
              <input class="form-control teach-compensation-input" formControlName="subjectCode" />
            </div>
          </div>
        </div>

        <div class="row teach-compensation-form-row teach-compensation-makeup-time-row">
          <div class="col-sm-4 teach-compensation-form-col">
            <div class="teach-compensation-label">วันที่ขอสอนชดเชย <span>*</span></div>
            <app-datepicker
              formControlName="compensationDate"
              [labelMode]="LabelMode.NO_LABEL"
              placeholder="วันที่ขอสอนชดเชย"
              [required]="true"
              [minDate]="minSelectableDate()"
              [maxDate]="maxSelectableDate()"
              [isDisabled]="form.get('compensationDate')?.disabled ?? true"
              [error]="isCompensationDateInvalid()"
              [errorMessage]="getCompensationDateErrorMessage()"
              classes="mb-0"
            ></app-datepicker>
          </div>

          <div class="col-sm-8 teach-compensation-form-col teach-compensation-time-range-col">
            <div class="teach-compensation-time-range-field">
              <div class="teach-compensation-time-range-control">
                <div class="teach-compensation-label">เวลาสอนชดเชย <span>*</span></div>
                <app-select
                  formControlName="compensationStartTime"
                  [labelMode]="LabelMode.NO_LABEL"
                  [options]="compensatoryTeachingTime()"
                  [searchable]="false"
                  [clearable]="true"
                  [isDisabled]="form.get('compensationStartTime')?.disabled ?? true"
                  [error]="isCompensationTimeInvalid('compensationStartTime')"
                  [errorMessage]="getCompensationTimeErrorMessage('compensationStartTime')"
                  inputClass="teach-compensation-details-select"
                  classes="mb-0"
                ></app-select>
              </div>

              <span class="teach-compensation-time-range-separator">ถึง</span>

              <div class="teach-compensation-time-range-control">
                <div class="teach-compensation-label teach-compensation-label-placeholder">
                  เวลาสอนชดเชย
                </div>
                <app-select
                  formControlName="compensationEndTime"
                  [labelMode]="LabelMode.NO_LABEL"
                  [options]="compensatoryTeachingTime()"
                  [searchable]="false"
                  [clearable]="true"
                  [isDisabled]="form.get('compensationEndTime')?.disabled ?? true"
                  [error]="isCompensationTimeInvalid('compensationEndTime')"
                  [errorMessage]="getCompensationTimeErrorMessage('compensationEndTime')"
                  inputClass="teach-compensation-details-select"
                  classes="mb-0"
                ></app-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row teach-compensation-form-row">
          <div class="col-12 teach-compensation-form-col">
            <div class="teach-compensation-label">คำอธิบาย</div>
            <app-textarea
              formControlName="description"
              [labelMode]="LabelMode.NO_LABEL"
              [rows]="3"
              placeholder="ระบุรายละเอียดเพิ่มเติม (ถ้ามี)"
            ></app-textarea>
            @if (isDescriptionTooLong()) {
              <span class="teach-compensation-field-error">
                คำอธิบายต้องไม่เกิน {{ descriptionMaxLength }} ตัวอักษร
              </span>
            }
          </div>
        </div>
      </div>

      <div class="teach-compensation-form-actions">
        <button type="button" class="btn teach-compensation-cancel-button" (click)="onCancel()">
          ยกเลิก
        </button>
        <button
          type="submit"
          class="btn teach-compensation-save-button"
          [disabled]="scheduleSubmissionLoadError() !== '' || isSubmitting()"
        >
          บันทึก
        </button>
      </div>
    </form>
  </div>

  <ng-template #submissionPreview let-dialog>
    <header class="teach-compensation-preview-dialog-header">
      <span class="teach-compensation-preview-dialog-icon" aria-hidden="true">!</span>
      <div class="teach-compensation-preview-dialog-heading-copy">
        <h5 id="teach-compensation-preview-title" class="teach-compensation-preview-dialog-title">
          ตรวจสอบคำขอสอนชดเชย
        </h5>
        <p class="teach-compensation-preview-dialog-intro">
          กรุณาตรวจสอบรายละเอียดก่อนยืนยันและบันทึกรายการ
        </p>
      </div>
      <button
        type="button"
        class="btn teach-compensation-preview-dialog-close"
        aria-label="ปิดหน้าต่างตรวจสอบคำขอสอนชดเชย"
        [disabled]="dialog.isProcessing"
        (click)="dialog.onCancel()"
      >
        <app-keenicon name="cross" type="outline" class="fs-2"></app-keenicon>
      </button>
    </header>

    <div class="teach-compensation-preview-dialog-body">
      <section class="teach-compensation-preview-section" aria-labelledby="teach-compensation-preview-leave-title">
        <h6 id="teach-compensation-preview-leave-title" class="teach-compensation-preview-section-title">
          ข้อมูลการลา / หยุด
        </h6>
        <dl class="teach-compensation-preview-leave-summary">
          <div class="teach-compensation-preview-item">
            <dt>ประเภทการลา / หยุด</dt>
            <dd>{{ previewLeaveType }}</dd>
          </div>
          <div class="teach-compensation-preview-item">
            <dt>{{ previewLeaveDateLabel }}</dt>
            <dd>{{ previewLeaveDate }}</dd>
          </div>
          <div class="teach-compensation-preview-item">
            <dt>ช่วงเวลา</dt>
            <dd>{{ previewLeavePeriod }}</dd>
          </div>
        </dl>
      </section>

      <section class="teach-compensation-preview-section" aria-labelledby="teach-compensation-preview-makeup-title">
        <h6 id="teach-compensation-preview-makeup-title" class="teach-compensation-preview-section-title">
          รายละเอียดการสอนชดเชย
        </h6>

        <div class="teach-compensation-preview-course-card">
          <div class="teach-compensation-preview-course-summary">
            <div class="teach-compensation-preview-course-copy">
              <span class="teach-compensation-preview-label">รายวิชา</span>
              <p class="teach-compensation-preview-course-name">
                {{ previewSubjectName }}<span class="teach-compensation-preview-subject-code">&nbsp;({{ previewSubjectCode }})</span>
              </p>
            </div>
          </div>

          <dl class="teach-compensation-preview-course-metadata">
            <div class="teach-compensation-preview-course-meta-item">
              <span class="teach-compensation-preview-course-meta-icon" aria-hidden="true">
                <app-keenicon name="calendar" type="outline" class="fs-3"></app-keenicon>
              </span>
              <div class="teach-compensation-preview-course-meta-copy">
                <dt>วันที่ขอสอนชดเชย</dt>
                <dd class="teach-compensation-preview-course-meta-value">{{ previewCompensationDate }}</dd>
              </div>
            </div>
            <div class="teach-compensation-preview-course-meta-item">
              <span class="teach-compensation-preview-course-meta-icon" aria-hidden="true">
                <app-keenicon name="time" type="outline" class="fs-3"></app-keenicon>
              </span>
              <div class="teach-compensation-preview-course-meta-copy">
                <dt>เวลาสอนชดเชย</dt>
                <dd class="teach-compensation-preview-course-meta-value">{{ previewCompensationTime }}</dd>
              </div>
            </div>
            <div class="teach-compensation-preview-duration">
              <dt>รวมเวลาสอน</dt>
              <dd>
                <span class="teach-compensation-preview-duration-badge">
                  {{ previewCompensationDuration }}
                </span>
              </dd>
            </div>
          </dl>
        </div>
      </section>

      <section class="teach-compensation-preview-section" aria-labelledby="teach-compensation-preview-description-title">
        <h6 id="teach-compensation-preview-description-title" class="teach-compensation-preview-section-title">
          คำอธิบาย
        </h6>
        <p class="teach-compensation-preview-description">{{ previewDescription }}</p>
      </section>
    </div>

    <footer class="teach-compensation-preview-dialog-actions">
      <button
        type="button"
        class="btn teach-compensation-preview-cancel-button"
        [disabled]="dialog.isProcessing"
        (click)="dialog.onCancel()"
      >
        กลับไปแก้ไข
      </button>
      <button
        type="button"
        class="btn teach-compensation-preview-confirm-button"
        [disabled]="dialog.isProcessing"
        [attr.aria-busy]="dialog.isProcessing"
        (click)="dialog.onConfirm()"
      >
        <span *ngIf="dialog.isProcessing" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        ยืนยัน
      </button>
    </footer>
  </ng-template>

  <app-confirm-dialog
    #submissionConfirmDialog
    modalId="teach-compensationSubmissionConfirmDialog"
    [contentTemplate]="submissionPreview"
    containerClass="mw-650px"
    contentClass="p-0 align-items-stretch text-start"
    [isProcessing]="isSubmitting()"
    (confirmed)="onConfirmSubmission()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #submissionErrorDialog
    modalId="teach-compensationSubmissionErrorDialog"
    icon="warning"
    title="ไม่สามารถสร้างคำขอสอนชดเชยได้"
    [message]="submissionErrorMessage"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="submissionErrorDialog.close()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #submissionSuccessDialog
    modalId="teach-compensationSubmissionSuccessDialog"
    icon="success"
    title="สร้างคำขอสอนชดเชยสำเร็จ"
    message="ดำเนินการสร้างคำขอสอนชดเชยสำเร็จ"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="onCloseSubmissionSuccess()"
  ></app-confirm-dialog>
</div>
